import { AuthContextProps } from "../components/auth-context";
import { getData, postData } from "./core";
import SpeedTestResult from "../types/speed-test-result";
export default class SpeedTestApi {
  static uri = "a/internet/speedTest";
  context: AuthContextProps;
  constructor(context: AuthContextProps) {
    this.context = context;
  }

  getAll(id: number, page: number, rows: number) {
    return getData({
      uri: SpeedTestApi.uri,
      id,
      params: `?page=${page}&rows=${rows}`,
      context: this.context,
    });
  }

  get(id: number, ip: string) {
    return getData({
      uri: SpeedTestApi.uri,
      id,
      params: `?ip=${ip}`,
      context: this.context,
    });
  }
  post(data: SpeedTestResult) {
    return postData({
      uri: SpeedTestApi.uri,
      context: this.context,
      data,
    });
  }
}
